<article>
    <div class="container">
            <div class="path">
                <div class="text">채용알림 > 작성하기 > 미리보기</div>
                <button (click)="unactivePreivew()">닫기</button>
            </div>
            <h1 class="h1">채용알림</h1>
        <div class="list-detail">
            <div class="recruitTitle">
                <h2>{{notice.title}}</h2>
                <h3 *ngIf="notice.immediateOpening">상시모집</h3>
                <h3 *ngIf="!notice.immediateOpening">{{notice.startDate}} ~ {{notice.endDate}}</h3>
                <div class="button">
                    <button class="list">
                        <a >목록으로</a>
                    </button>
                    <button class="apply">
                        <a >지원하기</a>
                    </button>
                </div>
            </div>
            <div class="contents">
                <div class="date">
                    <p>등록일</p>
                    <p>{{date |date: "yyyy-MM-dd"}}</p>
                </div>
                <img src="/assets/images/recruitDetail.png">
                <div class="table">
                    <table>
                        <tr>
                            <th scope="row">업무내용</th>
                            <td >
                                <li *ngFor="let jobDescription of jobDescriptions">· {{jobDescription}}</li>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">지원자격</th>
                            <td >
                                <li *ngFor="let essentialSkill of essentialSkills"> · {{essentialSkill}}</li>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">우대사항</th>
                            <td >
                                <li *ngFor="let extraSkill of extraSkills"> · {{extraSkill}}</li>
                            </td>
                        </tr>

                    </table>

                </div>
            </div>
        </div>
    </div>
</article>